import React from 'react';

export default function Campfire() {
	// 8
	let style = {
		st25: {
			fill:"#EAB049"
		},
		st78: {
			fill:"#AD6636"
		},
		st79: {
			fill:"#E2935D"
		},
		st11: {
			fill:"#FCB47E"
		},
		st80: {
			fill:"#E57B4C"
		},
		st81: {
			fill:"#FFD180"
		}
	};
	return (
		<g>
			<path style={style.st25} d="M47.3127594,328.740387C45.3333321,356.6666565,66.9141006,363.7528381,66.5,363.4296875
				c-2.0155411-4.0787659-19.1872406-34.6893005,0-66.096344c6.5,26.333313,36.7392654,43.333313,36.7392654,72.096344
				c0,18.4279175-16.5847015,33.5917969-36.7392654,33.5917969s-36.7392654-15.1638794-36.7392654-33.5917969
				C29.7607327,357.0037842,35.3333321,337.3333435,47.3127594,328.740387"/>
			<path style={style.st78} d="M24.2272949,353.2215576c-0.0014648-0.0006104-0.0026855-0.0014648-0.0039062-0.0020752
				c-0.0031738-0.0014648-0.0063477-0.0021973-0.0095215-0.0036621c-0.4082031-0.1899414-0.8237305-0.348877-1.2424316-0.4914551
				c-0.076416-0.026123-0.1523438-0.0539551-0.229248-0.0786133c-0.4060059-0.1296387-0.815918-0.2368164-1.2290039-0.3236084
				c-0.0820312-0.0172119-0.1638184-0.0317383-0.2458496-0.0472412c-0.4255371-0.0805664-0.8530273-0.1452637-1.2832031-0.1818848
				c-0.0285645-0.0024414-0.057373-0.0024414-0.0856934-0.0046387c-0.4189453-0.032959-0.8393555-0.0419922-1.2600098-0.0344238
				c-0.0698242,0.0012207-0.1394043,0-0.2092285,0.0024414c-0.4240723,0.0141602-0.8481445,0.0505371-1.2719727,0.1046143
				c-0.0842285,0.0107422-0.1679688,0.0230713-0.2521973,0.0352783c-0.4289551,0.0626221-0.8566895,0.1408691-1.2819824,0.243042
				c-0.0454102,0.0108643-0.0905762,0.0247803-0.1357422,0.0361328c-0.4104004,0.1026611-0.8178711,0.2242432-1.2226562,0.3626709
				c-0.0568848,0.0195312-0.1140137,0.036377-0.1708984,0.0566406c-0.4162598,0.1477051-0.8278809,0.3171387-1.2358398,0.5018311
				c-0.0795898,0.0360107-0.1586914,0.0726318-0.237793,0.1099854c-0.40625,0.1917725-0.8078613,0.3985596-1.2028809,0.6259766
				c-0.0537109,0.0308838-0.1064453,0.0646973-0.1599121,0.0964355c-0.1782227,0.1051025-0.3569336,0.2084961-0.5322266,0.3206787
				l0.0075684,0.0164795c-2.300293,1.4716797-4.3535156,3.5454102-5.9262695,6.1184082l-0.0041504-0.0020752
				c-0.020752,0.0338135-0.0395508,0.069458-0.0600586,0.1033936c-0.1325684,0.2199707-0.262207,0.4416504-0.3876953,0.6685791
				c-0.2294922,0.4080811-0.4511719,0.8233643-0.652832,1.2562256c-4.0319824,8.6464844-1.3815918,18.4162598,5.9199219,21.8212891
				l99.1555176,46.2368164l14.6013184-31.3125L24.2272949,353.2215576z"/>
			<polygon style={style.st79} points="14.7849979,421.2447815 15.6047935,414.9579773 6.2583299,425.2208252 		"/>
			<path style={style.st78} d="M129.2991333,362.7172546c-0.2002716-0.4294739-0.4198608-0.8412781-0.6472473-1.2464294
				c-0.1292419-0.2343445-0.2633209-0.4636841-0.4005585-0.6906433c-0.0179901-0.0297546-0.0346069-0.0610962-0.0528107-0.0911255
				l-0.0038147,0.0016479c-1.5727615-2.5729065-3.6262665-4.6467285-5.9265518-6.1184387l0.0072784-0.0160217l0,0
				c-0.0896759-0.0576172-0.1846924-0.1004639-0.275177-0.1559448c-0.3180389-0.1954346-0.6405945-0.3756104-0.9665756-0.5474854
				c-0.1813126-0.0957642-0.3605957-0.1950073-0.5439224-0.2831116c-0.3770981-0.1815186-0.7592163-0.3406677-1.1438599-0.4904785
				c-0.1364136-0.0528564-0.2700653-0.116272-0.4071884-0.1652527c-0.5229111-0.1871643-1.0508041-0.3453674-1.583107-0.4728088
				c-0.1162033-0.0275574-0.2333984-0.0409851-0.3500595-0.0661621c-0.4175568-0.0887146-0.8357391-0.1647644-1.2557678-0.2154846
				c-0.1889343-0.022644-0.3774719-0.0315552-0.5666962-0.0466309c-0.3521805-0.0278625-0.7034912-0.0461121-1.0551605-0.0462341
				c-0.2047577-0.0000305-0.4079437,0.0071716-0.6119461,0.0167847c-0.3421631,0.0158997-0.682106,0.046936-1.0219879,0.0899963
				c-0.1999969,0.0253906-0.3987885,0.0496521-0.5978088,0.0849304c-0.3608932,0.0632629-0.7174377,0.1497192-1.073822,0.2454834
				c-0.1688995,0.0452576-0.3376083,0.0800171-0.5051956,0.1327209c-0.5193634,0.163147-1.0304413,0.2391968-1.533905,0.4740601
				L108.7797546,353h-0.0019913L9.6222658,399.3500366l14.6012278,31.3688354l99.1554337-46.2088623
				C130.6804962,381.1053467,133.3310242,371.3637695,129.2991333,362.7172546z"/>
			<path style={style.st11} d="M15.59233,415.1017761l-8.4853773,9.50177c-0.905365-1.1388855-1.7089648-2.4068298-2.3614302-3.8060303
				c-3.7572303-8.0574036-1.3515511-17.1595154,5.3634634-20.290802c6.7150154-3.1312561,15.2339764,0.8766174,18.9912071,8.934021
				s1.3515511,17.1595154-5.3634644,20.2907715c-3.3287125,1.5522156-7.0995693,1.3459167-10.5150309-0.2341309L15.59233,415.1017761
				z"/>
			<path style={style.st78} d="M30.160593,408.9909058c-4.0081234-8.6576843-13.1840611-12.9326477-20.495039-9.5479431
				c-7.3110166,3.3844604-9.9884109,13.1470032-5.9803486,21.8046875c0.6966441,1.5046692,1.5574725,2.8673401,2.5294988,4.0900269
				l3.0725169-2.6615295c-0.7577572-0.9728394-1.403574-2.0150146-1.9115882-3.10495
				c-3.0813799-6.6071777-1.3050895-13.9799194,3.959168-16.4347534c5.2623978-2.4559631,12.0543137,0.92276,15.1356087,7.5309143
				c3.0804062,6.6070862,1.3041172,13.9798584-3.9600983,16.4341736c-2.5059834,1.169342-5.4528484,1.0473022-8.22754-0.3031921
				l-0.4933329-0.2695923l-0.3463678,1.8111877c-0.0116348-0.0056763-0.0237226-0.0096741-0.0353565-0.0153503l-0.4503717,2.3206482
				c3.640686,1.6183777,7.6527424,1.8029785,11.2227402,0.1500854
				C31.4911613,427.4108582,34.1686172,417.6483154,30.160593,408.9909058z"/>
			<path style={style.st11} d="M109.2638931,429.7250061c-6.7150116-3.1312866-9.120697-12.2333679-5.3634644-20.290802
				c3.7572327-8.0574036,12.2761917-12.0652466,18.9912109-8.9339905s9.1206894,12.2333679,5.3634567,20.2907715
				C124.4978714,428.8483887,115.9789124,432.8562622,109.2638931,429.7250061z"/>
			<path style={style.st78} d="M123.3782883,399.4563904c-7.3015671-3.4046631-16.4892502,0.844635-20.5211411,9.4911499
				c-4.0319901,8.646759-1.3816147,18.4163208,5.9199753,21.821228c7.3016968,3.4046326,16.4893799-0.8446655,20.5213852-9.4911804
				C133.3303833,412.6308289,130.6798859,402.8612671,123.3782883,399.4563904z M125.5361938,419.5231323
				c-2.157074,4.6255188-6.3185577,7.8564758-10.6019974,8.2312317c-1.5631256,0.1367493-3.0443115-0.1149902-4.4024048-0.7483215
				c-5.2153244-2.4318848-6.9704285-9.7459717-3.9124451-16.3040466c2.1569443-4.6255188,6.3184357-7.8564453,10.6017532-8.2312012
				c1.5632401-0.1367798,3.0444336,0.1149902,4.4026718,0.7485352c2.426445,1.1314392,4.1937866,3.3849182,4.9762878,6.3455505
				C127.4351196,412.7243347,127.0573425,416.2609558,125.5361938,419.5231323z"/>
			<polygon style={style.st79} points="115.8529739,414.5727844 114.374649,403.1390381 98.3333359,396.5 	"/>
			<path style={style.st80} d="M47.3127594,328.740387C45.3333321,356.6666565,66.9141006,363.7528381,66.5,363.4296875
				c-2.0155411-4.0787659-19.1872406-34.6893005,0-66.096344c6.5,26.333313,36.7392654,43.333313,36.7392654,72.096344
				c0,18.4279175-16.5847015,33.5917969-36.7392654,33.5917969s-36.7392654-15.1638794-36.7392654-33.5917969
				C29.7607327,357.0037842,35.3333321,337.3333435,47.3127594,328.740387"/>
			<path style={style.st81} d="M52.7858887,352.2927246c-5.3242188,6.4748535-8.0266113,13.1838379-8.0266113,19.9611816
				c0,7.5947266,9.6972656,16.7675781,21.7392578,16.7675781c6.4257812,0,12.8847656-2.6782227,17.2753906-7.1640625
				c2.9033203-2.965332,4.5302734-6.4345703,4.4648438-9.5180664c-0.2373047-11.0908203-8.4492188-18.2519531-17.9580078-26.5439453
				c-4.338623-3.7834473-8.786499-7.6669922-12.5891113-12.1130371c0.9409523,12.9323425,5.5307884,23.1647339,7.7665482,27.6852722
				c0.369278,0.7466431-0.4172745,1.5385132-1.1632538,1.1678772
				C61.5106201,361.1520996,56.6252289,358.0449829,52.7858887,352.2927246z"/>
			<polygon style={style.st81} points="50.668335,348.5983887 50.6679688,348.5976562 50.6677246,348.5979004 		"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Campfire.js